document.addEventListener('DOMContentLoaded', function () {

  /* ── CURSOR ── */
  const cur = document.querySelector('.cursor');
  const ring = document.querySelector('.cursor-ring');
  if (cur && ring && window.innerWidth > 768) {
    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', e => {
      mx = e.clientX;
      my = e.clientY;
      cur.style.left = mx + 'px';
      cur.style.top = my + 'px';
    });
    function loop() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top = ry + 'px';
      requestAnimationFrame(loop);
    }
    loop();
    const hoverEls = 'a, button, .video-card, .prod-card, .soc-btn';
    document.querySelectorAll(hoverEls).forEach(el => {
      el.addEventListener('mouseenter', () => {
        cur.classList.add('expand');
        ring.classList.add('expand');
      });
      el.addEventListener('mouseleave', () => {
        cur.classList.remove('expand');
        ring.classList.remove('expand');
      });
    });
  }

  /* ── ANNOUNCEMENT BANNER ── */
  const bar = document.querySelector('.announce-bar');
  const close = document.querySelector('.announce-close');
  const nav = document.querySelector('.site-nav');

  function showBanner() {
    if (!bar || sessionStorage.getItem('banner-closed')) return;
    bar.classList.add('show');
    nav && nav.classList.add('banner-open');
  }
  function hideBanner() {
    if (!bar) return;
    bar.classList.remove('show');
    nav && nav.classList.remove('banner-open');
    sessionStorage.setItem('banner-closed', '1');
  }

  const isHome = window.location.pathname === '/';
  if (isHome) {
    setTimeout(showBanner, 1500);
  } else {
    setTimeout(showBanner, Math.random() * 4000 + 3000);
  }
  close && close.addEventListener('click', hideBanner);

  /* ── NAV SCROLL ── */
  if (nav) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      nav.classList.toggle('scrolled', currentScroll > 50);
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ── ACTIVE NAV LINK ── */
  const path = window.location.pathname;
  document.querySelectorAll('.nav-links a').forEach(a => {
    const href = a.getAttribute('href');
    if (href === path || (href !== '/' && path.startsWith(href))) {
      a.classList.add('active');
    }
  });

  /* ── MOBILE NAV ── */
  const burger = document.querySelector('.hamburger');
  const mob = document.querySelector('.mobile-nav');
  const mclose = document.querySelector('.mobile-close');
  
  function openMob() {
    mob?.classList.add('open');
    burger?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMob() {
    mob?.classList.remove('open');
    burger?.classList.remove('open');
    document.body.style.overflow = '';
  }
  
  burger?.addEventListener('click', openMob);
  mclose?.addEventListener('click', closeMob);
  mob?.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMob));

  /* ── PAGE TRANSITIONS ── */
  const curtain = document.querySelector('.curtain');
  if (curtain) {
    curtain.classList.add('out');
    setTimeout(() => curtain.classList.remove('out'), 450);
    document.querySelectorAll('a[href]').forEach(a => {
      const href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('http') || href.startsWith('mailto') || a.target === '_blank') return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        const dest = this.getAttribute('href');
        curtain.classList.add('in');
        setTimeout(() => { window.location.href = dest; }, 400);
      });
    });
  }

  /* ── SCROLL REVEAL ── */
  const revEls = document.querySelectorAll('.reveal');
  if (revEls.length) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (en.isIntersecting) {
          en.target.classList.add('visible');
          obs.unobserve(en.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    revEls.forEach(el => obs.observe(el));
  }

  /* ── VIDEO HOVER PREVIEWS ── */
  if (window.innerWidth > 768) {
    document.querySelectorAll('.video-card').forEach(card => {
      const prev = card.querySelector('.vthumb-video');
      if (!prev) return;
      let hoverTimer;
      card.addEventListener('mouseenter', () => {
        hoverTimer = setTimeout(() => {
          prev.play().catch(() => {});
        }, 300);
      });
      card.addEventListener('mouseleave', () => {
        clearTimeout(hoverTimer);
        prev.pause();
        prev.currentTime = 0;
      });
    });
  }

  /* ── AMBIENT MUSIC ── */
  const musicBtn = document.querySelector('.music-btn');
  const nowPlaying = document.querySelector('.now-playing');
  let playing = false;
  let currentAudio = null;

  function startAmbient() {
    const songs = [
      "https://cdn.shopify.com/s/files/1/0793/0730/9297/files/Nine_Vicious_-_Love_Crazy_Instrumental.mp3?v=1776022892",
      "https://cdn.shopify.com/s/files/1/0793/0730/9297/files/Nine_Vicious_-_Italy_Instrumental.mp3?v=1776023167",
      "https://cdn.shopify.com/s/files/1/0793/0730/9297/files/Nine_Vicious_-_Coors_Light_Instrumental.mp3?v=1776023166"
    ];
    const pick = songs[Math.floor(Math.random() * songs.length)];
    currentAudio = new Audio(pick);
    currentAudio.loop = true;
    currentAudio.volume = 0.15;
    currentAudio.play().catch(() => {});
  }

  function stopAmbient() {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
      currentAudio = null;
    }
  }

  musicBtn?.addEventListener('click', () => {
    if (!playing) {
      startAmbient();
      playing = true;
      musicBtn.classList.add('playing');
      musicBtn.querySelector('.mi').textContent = '◉';
      nowPlaying?.classList.add('show');
    } else {
      stopAmbient();
      playing = false;
      musicBtn.classList.remove('playing');
      musicBtn.querySelector('.mi').textContent = '♪';
      nowPlaying?.classList.remove('show');
    }
  });

  /* ── AJAX ADD TO CART ── */
  document.querySelectorAll('.ajax-atc').forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      const id = this.dataset.variantId;
      if (!id) return;
      const orig = this.textContent;
      this.textContent = 'Adding…';
      this.disabled = true;
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, quantity: 1 })
        });
        if (r.ok) {
          this.textContent = 'Added ✓';
          const cart = await (await fetch('/cart.js')).json();
          const badge = document.querySelector('.cart-count');
          if (badge) {
            badge.textContent = cart.item_count;
          } else if (cart.item_count > 0) {
            const el = document.createElement('span');
            el.className = 'cart-count';
            el.textContent = cart.item_count;
            document.querySelector('.cart-icon')?.appendChild(el);
          }
        } else {
          this.textContent = 'Error';
        }
      } catch {
        this.textContent = 'Try again';
      }
      setTimeout(() => {
        this.textContent = orig;
        this.disabled = false;
      }, 2000);
    });
  });

});
